import React from "react";
import { Button } from "@/components/ui/button";

export default function HomeBanner({ title, subtitle, buttonLabel, icon: Icon, onClick, actions }) {
  return (
    <div className="bg-slate-900 text-white rounded-3xl p-6 sm:p-8 flex flex-col justify-between gap-6 min-h-[190px] dark:bg-slate-800">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold tracking-tight">{title}</h2>
        <p className="text-slate-300 mt-1 text-sm">{subtitle}</p>
      </div>
      {actions ? (
        <div className="flex flex-wrap gap-3 self-start">
          {[...actions].sort((a,b)=>String(a.label||"").localeCompare(String(b.label||""))).map((a, i) => (
            <Button
              key={i}
              onClick={a.onClick}
              className="bg-white text-slate-900 hover:bg-slate-100 rounded-xl gap-2"
            >
              {a.icon ? <a.icon className="w-4 h-4" /> : null}
              {a.label}
            </Button>
          ))}
        </div>
      ) : (
        <Button
          onClick={onClick}
          className="bg-white text-slate-900 hover:bg-slate-100 rounded-xl gap-2 self-start"
        >
          {Icon ? <Icon className="w-4 h-4" /> : null}
          {buttonLabel}
        </Button>
      )}
    </div>
  );
}